import { Calendar } from "lucide-react";
import ReusableDropdown from "../../../../components/ReusableDropdown";
import { PALETTE } from "../../styles/configStyles";

const PayrollDatesTab = ({
  styles,
  theme,
  isRTL,
  language,
  config,
  setConfig,
  canEditField,
  isEditingArchive,
}) => {
  const canEdit = canEditField("company");
  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  
  // Create items for ReusableDropdown
  const dayItems = days.map((d) => ({ value: String(d), label: String(d) }));

  return (
    <div style={{marginTop: "24px", marginBottom: "24px"}}>
      <h3 style={styles.sectionTitle}>
        <div style={styles.sectionIconBadge(PALETTE.cyan.base)}>
          <Calendar size={20} />
        </div>
        {language === "ar" ? "إعدادات تاريخ الراتب" : "Payroll Date Settings"}
        {isEditingArchive && (
          <span style={{
            fontSize: "11px",
            fontWeight: 700,
            marginLeft: isRTL ? "0" : "12px",
            marginRight: isRTL ? "12px" : "0",
            padding: "4px 12px",
            borderRadius: "6px",
            background: `${PALETTE.amber.base}15`,
            color: PALETTE.amber.base,
            border: `1px solid ${PALETTE.amber.base}25`,
          }}>
            {language === "ar" ? "التاريخ" : "HISTORY"}
          </span>
        )}
      </h3>

      <p style={{ color: theme === "dark" ? "rgba(255,255,255,0.65)" : "rgba(15,23,42,0.65)", fontSize: "14px", marginBottom: "28px", lineHeight: "1.6" }}>
        {language === "ar"
          ? "حدد يوم بداية دورة الرواتب الشهرية."
          : "Define the start day of the monthly payroll cycle."}
      </p>

      <div style={styles.formRow}>
        <div style={styles.formGroup}>
          <label style={styles.label}>
            {language === "ar" ? "يوم بداية الراتب" : "Payroll Start Day"}
          </label>
          <ReusableDropdown
            items={dayItems}
            value={config.payrollStartDate ? String(config.payrollStartDate) : ""}
            onChange={(value) =>
              canEdit && setConfig((prev) => ({ ...prev, payrollStartDate: value ? parseInt(value) : null }))
            }
            placeholder={language === "ar" ? "-- اليوم --" : "-- Day --"}
            theme={theme}
            language={language}
            disabled={!canEdit}
            getItemKey={(item) => item.value}
            getItemLabel={(item) => item.label}
            inputStyle={{
              borderRadius: 12,
              border: isEditingArchive ? `1.5px solid ${PALETTE.amber.base}` : `1.5px solid ${theme === "dark" ? "rgba(148,163,184,0.2)" : "rgba(226,232,240,0.9)"}`,
              fontSize: 14,
              padding: "11px 14px",
              background: isEditingArchive
                ? theme === "dark" ? `${PALETTE.amber.base}08` : "rgba(255,251,235,0.8)"
                : theme === "dark" ? "rgba(30,41,59,0.8)" : "#ffffff",
              color: theme === "dark" ? "#f1f5f9" : "#334155",
              opacity: !canEdit ? 0.7 : 1,
              cursor: !canEdit ? "not-allowed" : "pointer",
            }}
          />
        </div>
      </div>

      {config.payrollStartDate && (
        <div style={{
          marginTop: 8,
          padding: "16px 20px",
          borderRadius: 12,
          background: `${PALETTE.cyan.base}08`,
          border: `1px solid ${PALETTE.cyan.base}25`,
          fontSize: 14,
          color: theme === "dark" ? PALETTE.cyan.light : PALETTE.cyan.dark,
          fontWeight: 600,
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}>
          <Calendar size={18} />
          {language === "ar"
            ? `دورة الراتب تبدأ من يوم ${config.payrollStartDate}`
            : `Payroll cycle starts on day ${config.payrollStartDate}`}
        </div>
      )}
    </div>
  );
};

export default PayrollDatesTab;